import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { Header } from '@navigationMenu/Header';
import { useDriverStore } from '@store/driverInfoStore';
import { PolicyNumber } from '@screens/hiring/confirm/policyNumber/PolicyNumber';
import AddIcon from '@mui/icons-material/Add';

export const HeaderPlans = () => {
  const { driver } = useDriverStore();
  const history = useHistory();

  return (
    <Grid container sx={{ display: 'flex', justifyContent: 'space-between', rowGap: '24px' }}>
      <Grid item xs={12} sm={12} md={6}>
        <Header
          title={
            driver.name === '' ? '¡Todo listo!' : `¡Todo listo ${driver.name}!`
          }
          subtitle={
            'Aquí están todas las opciones que tenemos para ti. ¡Elige tu favorita y personalízala! '
          }
        />
      </Grid>
      <Grid item xs={5} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'end' }}>
        <PolicyNumber />
      </Grid>
      <Grid item xs={5} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'end' }}>
        <Button
          startIcon={<AddIcon />}
          onClick={() => {
            history.push('/home');
          }}
          variant="outlined"
          style={{
            textTransform: 'none',
            marginRight: '15px',
            backgroundColor: '#FFFFFF',
            padding: '14px 19px 14px 19px',
            borderRadius: '4px',
            height: '40px'
          }}
        >
          Nueva cotización
        </Button>
      </Grid>
    </Grid>
  );
};
